export default __webpack_public_path__ + "static/media/Project5.0d044370.png";